import React                     from 'react';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  Modal
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import DraggableResizableDialog2 from '../ui/DraggableResizableDialog2';
import TitleWithFlowLogo         from '../ui/TitleWithFlowLogo';
import aboutDialogModel          from './AboutDialogModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  versionContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

interface IAboutDialogProps {
}

type AboutDialogProps = WithStyle<ReturnType<typeof styles>, IAboutDialogProps>;

class AboutDialog extends React.PureComponent<AboutDialogProps> {
  constructor(props: AboutDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    aboutDialogModel.reset();
  }

  getTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText='About' />;
  };

  renderDialogContents = React.memo((): JSX.Element => {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.versionContainer}>
        <div className='content'>
          <Typography>Version {aboutDialogModel.version}</Typography>
        </div>
      </div>
    )} />;
  });

  render() {
    return  <Observe render={() => (
      <DraggableResizableDialog2 defaultWidth='310px' DialogProps={{dialog: aboutDialogModel, disableEscapeKeyDown: false, title: this.getTitle}} DraggableResizableBoxProps={{enableResizing: false, minWidth: '230px', minHeight: '207px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog2>
    )} />;
  }
}

export default withStyles<IAboutDialogProps>(styles, AboutDialog);
